// extracted by mini-css-extract-plugin
export default {"root":"CreateProposalFooter_root__XPD0N","deposits":"CreateProposalFooter_deposits__JGmpT"};